import React, {
    useContext
} from 'react';
import { Image } from '@jutro/components';
import { LocaleService, TranslatorContext} from '@jutro/locale';
import './infoBanner.scss';
import UtilService from '../../services/UtilService';

const InfoBanner = ({
    className = '',
    iconSrc = '/branding/info-icon.svg',
    iconAlt = '',
    text,
    faqText = '',
    text2 = '',
}) => {
    const translator = useContext(TranslatorContext);
    return (
        <div className={`infoWCBIdBanner ${className}`.trim()}>
            <div className="infobannerCotainerRect" />
            <div className="infoWCBIdBannerInfo">
                <Image
                    alt={iconAlt}
                    figcaption=""
                    src={iconSrc}
                    height="32px"
                    width="32px"
                    className="infoIcon"
                />
                <div className="infobannerContent">
                    {
                        faqText !== '' ? <span className="spanBanner">{translator(text)}
                            <a className= "bluelink" target='_blank' href={UtilService.faq(LocaleService.getStoredLanguage())}>{translator(faqText)}</a>{translator(text2)}</span> :
                            <span className="spanBanner">{translator(text)}</span>
                    }
                    
                </div>
            </div>
        </div>
    );
};

export default InfoBanner;
